
import { AssetMaintenanceMetadataBase } from './asset-maintenance.metadata.base';


export class AssetMaintenanceMetadata extends AssetMaintenanceMetadataBase {
  constructor() {
    super();
  }
}

export const ASSET_MAINTENANCE_METADATA: AssetMaintenanceMetadata = new AssetMaintenanceMetadata();


